// extracted by mini-css-extract-plugin
export var attachment = "_hs-a";
export var emailContainer = "_hs-4";
export var emailContentPaddedContainer = "_hs-b";
export var emailHeader = "_hs-6";
export var emailIframe = "_hs-3";
export var emailInfoIcon = "_hs-9";
export var emailShortenedSummary = "_hs-e";
export var infoDropdown = "_hs-0";
export var infoRowBoundedContent = "_hs-d";
export var internal = "_hs-5";
export var merchant = "_hs-8";
export var messageInputContainer = "_hs-h";
export var normal = "_hs-7";
export var replyCard = "_hs-f";
export var subtleButton = "_hs-1";
export var subtleButtonIconContainer = "_hs-2";
export var toggleViewRepliesButton = "_hs-c";
export var wrappingText = "_hs-g";